// Import the functions you need from the SDKs you need

import { initializeApp,  } from "firebase/app";
import { getStorage, ref, uploadBytes, getBlob, StorageError } from "firebase/storage";
import { firebaseConfig, _securityKey, _userUniqueId, _debugMode, _maxSyncCallsPerMinute, _cachedLocalAutoL2image, _appVersion } from "./constants";
import { checkIfValidVariable, compareDataDicts, compressData, containsAllWords, decompressData, mergeDictsWithPriority, mergeNodes, mergeVarsWithPriority, rateLimit } from "./foo";
import { DataDict, isDataDict } from "./types";
import { cloneDeep } from 'lodash';
import { getFirestore, doc, setDoc, updateDoc, getDoc } from "firebase/firestore";





// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
const app = initializeApp(firebaseConfig);
export const firebaseStorage = getStorage(app);
const db = getFirestore(app);

export const rateLimitedSync = rateLimit(sync, _maxSyncCallsPerMinute, 60*1000);

//REF-1
async function sync(nodes:any, l2image:any, l2audio:any, l2visibility:any, l2color:any,
    userUniqueId:string | null, userEmail:string | null,
    setNodes:any, setL2Audio:any, setL2Image:any, setL2Visibility:any, setL2Color:any,
    keepLocal:boolean, clearData:boolean,
    homeNodePath:string,
    setHomeNodePath:any,
    topSentences:any)
{
    if(_debugMode){console.log("CALLED sync.")}
    if(userEmail == null || userUniqueId == null){return false;}
    const storageSystem = 0; // hard-coded right now. Later based on convenience.
    const mergeData = !clearData;



    let localData: DataDict = { //REF-1 REF-2
        nodes:nodes,
        l2image:l2image,
        l2audio:l2audio,
        l2visibility:l2visibility,
        l2color:l2color,
        storageSystem: storageSystem,
        homeNodePath: homeNodePath,
        topSentences: topSentences
    }
    if(_debugMode){console.log("[sync] localData=",localData)};

    let resFromDownData: any;
    let resFromUpData: boolean = false;
    let doDownload:boolean = mergeData || !keepLocal;
    let doUpload:boolean = mergeData || keepLocal;
    if(_debugMode){console.log("[sync] mergeData=",mergeData,"; keepLocal=",keepLocal, "; doDownload=",doDownload,"; doUpload=",doUpload);}

    if(doDownload){
        resFromDownData = await downData(nodes, l2image, l2audio, l2visibility, l2color,
                                   keepLocal, storageSystem,
                                   userUniqueId, userEmail, mergeData,
                                   homeNodePath, topSentences); //REF-1 REF-2
    }  

    if(_debugMode){console.log("[sync] #1: resFromDownData =",resFromDownData);}
    
    if(doDownload && isDataDict(resFromDownData)){
        if(compareDataDicts(resFromDownData,localData)){
            if(_debugMode){console.log("[sync] : Setting doUpload = false.");}
            doUpload = false; // avoid upload if remote data equals local one
        }
    }
    if(_debugMode){console.log("[sync] #2: resFromDownData =",resFromDownData);}
    if(resFromDownData === true || resFromDownData === undefined){// it is true but not object? It means remote path not found.
        if(_debugMode){console.log("[sync] : setting resFromDownData = localData");}
        resFromDownData = cloneDeep(localData);
        if(_debugMode){console.log("[sync] : resFromDownData =",resFromDownData);}
    }

    if(_debugMode){console.log("[sync] : doUpload=",doUpload);}
    if(doUpload && (!doDownload || resFromDownData)){
            //REF-1 REF-2
            resFromUpData = await upData(resFromDownData.nodes, resFromDownData.l2image, resFromDownData.l2audio,
                                      resFromDownData.l2visibility, resFromDownData.l2color, resFromDownData.storageSystem,
                                      resFromDownData.homeNodePath,
                                      userUniqueId, userEmail, topSentences);
            if(_debugMode){console.log("[sync] : resFromUpData =",resFromUpData);}
    }

    //REF-2
    if((!doUpload && resFromDownData) || (resFromUpData && doUpload)){
        if(_debugMode){console.log("[sync] : Calling setter functions. Setting local data equal to resFromDownData=",resFromDownData);}
        setNodes(resFromDownData.nodes);
        setL2Image(resFromDownData.l2image);
        setL2Audio(resFromDownData.l2audio);
        setL2Visibility(resFromDownData.l2visibility);
        setL2Color(resFromDownData.l2color);
        setHomeNodePath(resFromDownData.homeNodePath);
        return true; // result from download is valid (not false) but upload must not be exeuted
    }
    return false;
}

async function upData(nodes:any, l2image:any, l2audio:any, l2visibility:any, l2color:any, storageSystem:number,
    homeNodePath:string,
    userUniqueId:string, userEmail:string, topSentences:any){//REF-1 REF-2
    if(!checkIfValidVariable(userUniqueId) || !checkIfValidVariable(userEmail)){return false;}
    if(_debugMode){console.log("CALLED upData.")}
    try {

        if(storageSystem == 0){
            let res;
            //REF-1
            //REF-2
            const data: DataDict = {nodes: nodes,
                        l2image: l2image,
                        l2audio: l2audio,
                        l2visibility: l2visibility,
                        l2color: l2color,
                        storageSystem: storageSystem,
                        homeNodePath: homeNodePath,
                        topSentences: topSentences

                    };
            if(_debugMode){console.log("Uploading ", data)}
            const compressed_data = compressData(data);
            if(_debugMode){console.log("Compressed data")}
            if(_debugMode){console.log("Defining objRef at ",userUniqueId+"_"+userEmail+"/data")}
            const objRef = ref(firebaseStorage, userUniqueId+"_"+userEmail+"/data");
            if(_debugMode){console.log("Defined objRef")}

            //const blob = new Blob([JSON.stringify(data, null, 2)], {type: "application/json"}); // To use if data are not compressed
            const blob = new Blob([compressed_data], {type: "application/octet-stream"}); // To use if data are compressed


            if(_debugMode){console.log("Blob from:", data)}
            res = await uploadBytes(objRef, blob, {customMetadata : {securityKey: _securityKey}}).then((snapshot) => {
                if(_debugMode){console.log("Synched"); console.log("Uploaded", snapshot.metadata.size,"Bytes")}
                return true;
            }).catch(e => {
                if(_debugMode){console.log("Sync Error #1", e,". _securityKey=",_securityKey)}
                return false;
            });

            if(res){
                return true;
            }
        }

    }catch(error){
        if(_debugMode){console.log("Sync Error #2", error )}
        return false;
    }
    return false;
    
}

async function downData(
    nodes:any, l2image:any, l2audio:any, l2visibility:any, l2color:any,
    keepLocal:boolean,
    storageSystem:number,
    userUniqueId:string, userEmail:string,
    mergeData:boolean,
    homeNodePath:string,
    topSentences:any) //REF-1 REF-2
    {
    if(_debugMode){console.log("CALLED downData. userUniqueId=",userUniqueId,"userEmail=",userEmail)}
    if(!checkIfValidVariable(userUniqueId) || !checkIfValidVariable(userEmail)){return false;}
    try {

        if(storageSystem == 0){ // bulk storage: minimize number of operations, but keep data bigger.
            const objRef = ref(firebaseStorage, userUniqueId+"_"+userEmail+"/data");
            try{
                var blob = await (await getBlob(objRef));

                //const remoteData = JSON.parse(await blob.text()); // if no data/blog compression was made during upload
                const remoteData: DataDict = decompressData(new Uint8Array(await new Response(blob).arrayBuffer())); // if data (but not blob) compression was made before
                
                
                if(_debugMode){console.log("From downData: remoteData=",remoteData)}
                var dataPriority = 1;
                if(keepLocal == false){
                    dataPriority = 2
                }

                let data: DataDict;

                if(mergeData){
                    let mergedNodes;
                    // if user wants to give local data dicts priority, I assume he also wants to preserve local nodes order
                    // otherwise remote nodes order is preserved.
                    if(keepLocal){
                        mergedNodes = mergeNodes(nodes,remoteData.nodes);
                    }else{
                        mergedNodes = mergeNodes(remoteData.nodes, nodes);
                    }
                    const mergedImage = mergeDictsWithPriority(l2image, remoteData.l2image, dataPriority);
                    const mergedAudio = mergeDictsWithPriority(l2audio, remoteData.l2audio, dataPriority);
                    const mergedVisibility = mergeDictsWithPriority(l2visibility, remoteData.l2visibility, dataPriority);
                    const mergedColor = mergeDictsWithPriority(l2color, remoteData.l2color, dataPriority);
                    //REF-1 REF-2
                    const mergedHomeNodePath = mergeVarsWithPriority(homeNodePath, remoteData.homeNodePath, dataPriority) as string;

                    //REF-1 REF-2
                    data = {
                        nodes:mergedNodes,
                        l2image:mergedImage,
                        l2audio:mergedAudio,
                        l2visibility:mergedVisibility,
                        l2color:mergedColor,
                        storageSystem: remoteData.storageSystem,
                        homeNodePath: mergedHomeNodePath,
                        topSentences: topSentences // should not be overwritten in any case
                    }
                }else{
                    //REF-1 REF-2
                    data = {
                        nodes:remoteData.nodes,
                        l2image:remoteData.l2image,
                        l2audio:remoteData.l2audio,
                        l2visibility:remoteData.l2visibility,
                        l2color:remoteData.l2color,
                        storageSystem: remoteData.storageSystem,
                        homeNodePath: remoteData.homeNodePath,
                        topSentences: topSentences // should not be overwritten in any case
                    }
                }
                
   
                return data;               

                
            }catch(error){
                if(_debugMode){console.log("Error in downData:",error);}
                const storageError = error as StorageError;
                if(containsAllWords(["storage","object","not","found"], storageError.code)){
                    return true;
                }else{
                    return false;
                }
            }
        }
        /*
        const objRef = ref(storage, userUniqueId+"_"+userEmail+"/nodes");
        var blob = await (await getBlob(objRef));
        const remoteNodes = JSON.parse(await blob.text())        
        
        const objRef2 = ref(storage, userUniqueId+"_"+userEmail+"/images");
        var blob2 = await (await getBlob(objRef2));
        var remoteL2Image = JSON.parse(await blob2.text())
        
        const objRef3 = ref(storage, userUniqueId+"_"+userEmail+"/sounds");
        var blob3 = await (await getBlob(objRef3));
        var remoteL2Audio = JSON.parse(await blob3.text())
        
        const objRef4 = ref(storage, userUniqueId+"_"+userEmail+"/visibilities");
        var blob4 = await (await getBlob(objRef4));
        var remoteL2Visibility = JSON.parse(await blob4.text())
        

        var dataPriority = 1;
        if(keepLocal == false){
            dataPriority = 2
        }


        const mergedNodes = mergeNodes(nodes,remoteNodes);
        const mergedImage = mergeDictsWithPriority(l2image, remoteL2Image, dataPriority);
        const mergedAudio = mergeDictsWithPriority(l2audio, remoteL2Audio, dataPriority);
        const mergedVisibility = mergeDictsWithPriority(l2visibility, remoteL2Visibility, dataPriority);
        
        
        setNodes(mergedNodes);
        setL2Image(mergedImage);
        setL2Audio(mergedAudio);
        setL2Visibility(mergedVisibility);

        store("nodes", mergedNodes);
        store("image", mergedImage);
        store("audio", mergedAudio);
        store("visibility", mergedVisibility);
        */
        return true;
        
        
    } catch (error) {
        
        
        return false;
    }
    
}


/*
async function upVars(key:string, value:string, userUniqueId:string){
    if(checkIfValidVariable(userUniqueId)){return false;}
    var obj = await downVarsToJSON(userUniqueId);
    obj[key] = value;
    const objRef = ref(storage, userUniqueId+"/vars");
    const blob = new Blob([JSON.stringify(obj, null, 2)], {type: "application/json"});
    uploadBytes(objRef, blob, {customMetadata : {securityKey: _securityKey}}).then((snapshot) => { console.log("OK")}); 
}

export async function downVarsToJSON(userUniqueId:string){
    if(checkIfValidVariable(userUniqueId)){return false;}
    const objRef = ref(storage, userUniqueId+"/vars");
    var blob = await (await getBlob(objRef));
    return JSON.parse(await blob.text());
}*/


/* Function to upload and download objects to / from Firestore Storage using firebaseConfig credentials to a shared given location. */

export async function upObject(obj:any, userUniqueId:string, userEmail:string, location:string, objectName:string){
    if(!checkIfValidVariable(userUniqueId) || !checkIfValidVariable(userEmail)){return false;}
    try {
        const objRef = ref(firebaseStorage, location+"/"+objectName);
        //const blob = new Blob([JSON.stringify(obj, null, 2)], {type: "application/json"});
        // Compress data before uploading
        const blob = new Blob([compressData(obj)], {type: "application/octet-stream"});

        uploadBytes(objRef, blob, {customMetadata : {securityKey: _securityKey}}).then((snapshot) => { }); 
        return true;
    } catch (error) {
        return false;
    }   
}

/* Function to dowload objects from Firestore Storage using firebaseConfig credentials from a shared given location. */
export async function downObject(userUniqueId:string, userEmail:string, location:string, objectName:string){
    if(!checkIfValidVariable(userUniqueId) || !checkIfValidVariable(userEmail)){return false;}
    try {
        const objRef = ref(firebaseStorage, location+"/"+objectName);
        var blob = await (await getBlob(objRef));
        return decompressData(new Uint8Array(await new Response(blob).arrayBuffer()));
    } catch (error) {
        return false;
    }   
}


/* Checks if the remote object exists or not. If not, it returns false. If yes, it returns the object found. */
export async function checkRemoteObject(userUniqueId:string, userEmail:string, location:string, objectName:string){
    if(!checkIfValidVariable(userUniqueId) || !checkIfValidVariable(userEmail)){return false;}
    try {
        const objRef = ref(firebaseStorage, location+"/"+objectName);
        var blob = await (await getBlob(objRef));
        return decompressData(new Uint8Array(await new Response(blob).arrayBuffer()));
    } catch (error) {
        return false;
    }   
}


export async function addWord(word: string) {
    const wordsRef = doc(db, "words", "list");
    const docSnap = await getDoc(wordsRef);

    if (docSnap.exists()) {
        // Document exists
        const data = docSnap.data();
            if (data && data.words && Object.keys(data.words).length < 10000){
                data.words = limitListSize(data.words);
                
                
                if (data && data.words && data.words[word]) {
                    // Word already exists in list, update counter
                    await updateDoc(wordsRef, {
                        [`words.${word}`]: data.words[word] + 1
                    });
                } else {
                    // Word does not exist in list, add it with counter 1
                    await updateDoc(wordsRef, {
                        [`words.${word}`]: 1
                    });
                }
            }
        
    } else {
        // Document does not exist, create it with the given word and counter 1
        await setDoc(wordsRef, {
            words: {
                [word]: 1
            }
        });
    }
}



function limitListSize(words: { [key: string]: number }) {
    // Check if the size of the list is greater than 50 MB
    const listSize = JSON.stringify(words).length;
    if (listSize > 50 * 1024 * 1024) {
        // List size is greater than 50 MB
        // Delete words occurring just once
        let newWords: { [key: string]: number } = {};

        for (const [key, value] of Object.entries(words)) {
            if (value > 1) {
                newWords[key] = value;
            }
        }
        words = newWords;

        // Check if the size of the list is still greater than 50 MB
        const newListSize = JSON.stringify(words).length;
        if (newListSize > 50 * 1024 * 1024) {
            // List size is still greater than 50 MB
            // Delete words occurring twice
            newWords = {};
            for (const [key, value] of Object.entries(words)) {
                if (value > 2) {
                    newWords[key] = value;
                }
            }
            words = newWords;
        }
    }

    return words;
}
